/* SparkBlocks mobile sticky add-to-cart. Markup: snippets/sb-sticky-atc.liquid. Mirrors the real Dawn
   submit button and clicks it; never talks to /cart itself. This is the live rewrite (another session,
   2026-10-28/29, with sb-mobile-overlays) plus the homepage rules in update(). */
if (!customElements.get('sb-sticky-atc')) {
  customElements.define('sb-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.realBtn = document.getElementById('ProductSubmitButton-' + this.dataset.sectionId);
      this.btn = this.querySelector('.sb-sticky-atc__btn');
      if (!this.realBtn || !this.btn) return;
      this.spinner = this.btn.querySelector('.loading__spinner');
      this.form = this.realBtn.closest('product-form');
      this.controls = this.realBtn.closest('.product-form__buttons') || this.realBtn;
      this.mq = matchMedia('(max-width: 749px)');
      this.footers = new Set();
      this.observers = [];
      this.events = new AbortController();
      const signal = this.events.signal;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.btn.addEventListener('click', () => {
        if (this.unavailable() || this.hidden) return;
        this.clicked = true;
        this.realBtn.click();
      }, { signal });
      const mirror = new MutationObserver(() => this.mirror());
      mirror.observe(this.realBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      this.observers.push(mirror);
      const buyObserver = new IntersectionObserver(this.schedule);
      buyObserver.observe(this.controls);
      this.observers.push(buyObserver);
      const aside = new IntersectionObserver(entries => {
        entries.forEach(e => e.isIntersecting ? this.footers.add(e.target) : this.footers.delete(e.target));
        this.schedule();
      });
      document.querySelectorAll('.shopify-section-group-footer-group, .sb-about-cta').forEach(e => aside.observe(e));
      this.observers.push(aside);
      const size = new ResizeObserver(() => {
        this.schedule();
        window.sbMobileOverlays?.refresh();
      });
      size.observe(this);
      size.observe(this.controls);
      this.observers.push(size);
      const errorWrap = this.form?.querySelector('.product-form__error-message-wrapper');
      if (errorWrap) {
        const errors = new MutationObserver(() => {
          if (this.clicked && !errorWrap.hidden) {
            this.clicked = false;
            this.realBtn.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
        });
        errors.observe(errorWrap, { attributes: true, attributeFilter: ['hidden'] });
        this.observers.push(errors);
      }
      this.mq.addEventListener('change', this.schedule, { signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      document.addEventListener('sb:overlay-change', this.schedule, { signal });
      this.mirror();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observers?.forEach(observer => observer.disconnect());
      cancelAnimationFrame(this.frame);
      window.sbMobileOverlays?.refresh();
    }
    unavailable() {
      return this.realBtn.disabled || this.realBtn.getAttribute('aria-disabled') === 'true';
    }
    mirror() {
      const loading = this.realBtn.classList.contains('loading');
      this.btn.classList.toggle('loading', loading);
      this.spinner?.classList.toggle('hidden', !loading);
      this.btn.setAttribute('aria-disabled', String(this.unavailable()));
      this.soldOut = this.realBtn.disabled || (!loading && this.unavailable());
      this.update();
    }
    update() {
      if (!this.isConnected || !this.realBtn?.isConnected) return;
      const bounds = this.controls.getBoundingClientRect();
      // A real button that is not rendered at all (the homepage path finder keeps one buy form per
      // path and hides the inactive panels) reports an empty rect: never show the bar for it.
      const rendered = bounds.width > 0 || bounds.height > 0;
      // data-from-load (the product page): off screen above OR below. Without it (the homepage):
      // only once the controls have scrolled above the viewport, so the bar never covers the hero.
      const above = bounds.bottom <= 0;
      const mainControlsOffscreen = rendered && (this.hasAttribute('data-from-load') ? (above || bounds.top >= window.innerHeight) : above);
      const show = this.mq.matches && mainControlsOffscreen && this.footers.size === 0 && !this.soldOut && !window.sbMobileOverlays?.blocked;
      if (this.hidden !== !show) this.hidden = !show;
      if (this.classList.contains('is-visible') !== show) this.classList.toggle('is-visible', show);
      this.btn.tabIndex = show ? 0 : -1;
      window.sbMobileOverlays?.refresh();
    }
  });
}
